/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_EmptyInputs */

const vi_shop_group_empty = /** @type {(inputs: Shop_Group_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có nhóm nào khớp bộ lọc.`)
};

/**

* @param {Shop_Group_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_empty = /** @type {((inputs?: Shop_Group_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_empty(inputs)
});